var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdown2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7142 6.8336L10.9542 2.59361C11.0479 2.50064 11.1223 2.39004 11.1731 2.26818C11.2239 2.14632 11.25 2.01562 11.25 1.88361C11.25 1.75159 11.2239 1.62089 11.1731 1.49903C11.1223 1.37717 11.0479 1.26657 10.9542 1.1736C10.7668 0.987354 10.5134 0.882812 10.2492 0.882813C9.98502 0.882813 9.73156 0.987354 9.5442 1.1736L6.0042 4.7136L2.4642 1.1736C2.27684 0.987354 2.02339 0.882813 1.7592 0.882813C1.49502 0.882813 1.24156 0.987354 1.0542 1.1736C0.96152 1.26705 0.888195 1.37786 0.83843 1.4997C0.788666 1.62154 0.763441 1.752 0.764202 1.88361C0.763441 2.01521 0.788666 2.14567 0.83843 2.26751C0.888195 2.38935 0.96152 2.50016 1.0542 2.59361L5.2942 6.8336C5.38717 6.92733 5.49777 7.00173 5.61963 7.0525C5.74148 7.10326 5.87219 7.1294 6.0042 7.1294C6.13621 7.1294 6.26692 7.10326 6.38878 7.0525C6.51064 7.00173 6.62124 6.92733 6.7142 6.8336Z",
    fill: "#0F1414"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown2);
export default __webpack_public_path__ + "static/media/dropdown-2.7558fca2b7a7e82682c65662ca1251d3.svg";
export { ForwardRef as ReactComponent };